import { LoginService } from './../../../login/login.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PessoaService } from '../../pessoa.service';
import { SYSCONF_LIMIT, SYSCONF_SIGLA } from '../../../../app.api';
import { Estudantil } from '../estudantil';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
	selector: 'app-estudantil-list',
	templateUrl: './estudantilList.component.html',
	styleUrls: ['./estudantilList.component.scss']
})
export class EstudantilListComponent implements OnInit{
	estudantis: Estudantil[];
	public message:string = '';
	edit:boolean = false;
	detail:boolean = false;
	delete:boolean = false;
	params = null;
	page = 1;
	totalPages:number = 1;
	formExportar:FormGroup;
	recordsPerPage:number = SYSCONF_LIMIT;
	buscaForm: FormGroup;
	sigla = SYSCONF_SIGLA;
	constructor(private activatedRoute: ActivatedRoute,  private router: Router, private pessoaService:PessoaService, private loginService: LoginService, private formBuilder: FormBuilder, private modalService: NgbModal){
		this.buscaForm = this.formBuilder.group({
			id: this.formBuilder.control(''),
			nome_completo: this.formBuilder.control(''),
			cnpj: this.formBuilder.control(''),
			status: this.formBuilder.control(''),
		});
	}
	changePage(event){
		let page = parseInt(event);
		let newParams:Object = new Object();
		this.activatedRoute.params.subscribe(
			param => {
				for(let i in param) {
					if(i != 'page') 
						newParams[i] = param[i];
				}
			})
		if(!page)
		return;
		this.router.navigate(['/'+SYSCONF_SIGLA+`/estudantil/page/${page}`,newParams]);
	}
	ngOnInit(){ 
		
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		
		if(t.permissao.pessoa_estudantil.includes("EDITAR"))
			this.edit = true;
		if(t.permissao.pessoa_estudantil.includes("CONSULTAR"))
			this.detail = true;
		
		this.activatedRoute.params.subscribe(params => {
			this.paramsChange(params);
		});
	}
	paramsChange(params) {
		this.params = params;
		this.message = "";
		this.pessoaService.list('pessoa/estudantil',params)
		.subscribe(
			(estudantil) => {
				this.estudantis = estudantil.dados;
				this.totalPages = estudantil.paging.rows;
				this.page = params['page'];
			},
			(error) => {
				this.message = error.error.message;
			})
	}
	onSubmit(){
		this.router.navigate(['/'+SYSCONF_SIGLA+'/estudantil/page/1',this.buscaForm.value]);
	}
	getPermissao(modulo,secao){
		return this.loginService.getPermissao(modulo,secao);
	}

	initFormExportar(){
		this.formExportar = this.formBuilder.group({
			campos: new FormArray([]),
		});
	}

	openModal(modal) {
		this.initFormExportar();
		this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
	}
}
